import { getEnum } from '@/api/global'
import { toDetailPageConfig } from '../config/approvalCommon'
import { FuzzySearch, refreshApprovalStatus } from '@/api/domain/cars.js'

export default {
  data() {
    return {
      bizTypeList: [], // 审批内容
    }
  },
  computed: {
    // 审批类型
    m_accessModeOptions() {
      return this.m_parseStoreGetters('approvalType')
    },
    // 审批状态
    m_stateOptions() {
      return this.m_parseStoreGetters('approvalState')
    },
    // 审批内容
    m_bizTypeOptions() {
      return this.m_parseStoreGetters('approvalBizType')
    },
  },
  methods: {
    // 获取列表数据
    m_getApprovalTaskList() {
      this.$refs.baseListManagement.searchForm()
    },

    // 查看详情
    m_detailHandle(row) {
      toDetailPageConfig.call(this, row)
    },

    // 刷新状态
    m_refreshHandle({ id }) {
      this.$confirm('请您确认是否操作?', '提示', {
        confirmButtonText: '确认操作',
        cancelButtonText: '取消',
      }).then(async () => {
        const { code, data } = await refreshApprovalStatus({ id })
        if (code === 1 && data) {
          this.$refs?.baseListManagement?.searchForm()
        }
      }).catch(() => {
        this.$message.info('已取消')
      })
    },

    // 格式化getters
    m_parseStoreGetters(name) {
      const list = this.dictParseList(this.$store.getters[name])
      list.unshift({
        label: '全部',
        value: '',
      })
      return list
    },

    // 获取审批内容
    async m_getBizTypes() {
      const params = {
        type: 'approveType',
      }
      const { data, code } = await getEnum(params)
      if (code === 1) {
        data.forEach((item) => { item.label = item.name; item.value = item.code })
        data.unshift({ code: '', name: '全部' })
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'bizType', data })
        this.bizTypeList = data
      }
    },
    // 处理搜索数据
    m_dealWithSearch(val) {
      const params = val
      if (params.gmtCreate && params.gmtCreate.length > 0) {
        params.gmtCreateBegin = val.gmtCreate[0]
        params.gmtCreateEnd = val.gmtCreate[1]
      } else {
        // eslint-disable-next-line no-unused-expressions
        delete params.gmtCreateBegin && params.gmtCreateBegin
        // eslint-disable-next-line no-unused-expressions
        delete params.gmtCreateEnd && params.gmtCreateEnd
        delete params.gmtCreate
      }
      if (params.approvalTime && params.approvalTime.length > 0) {
        params.approvalTimeBegin = params.approvalTime[0]
        params.approvalTimeEnd = params.approvalTime[1]
      } else {
        // eslint-disable-next-line no-unused-expressions
        delete params.approvalTimeBegin && params.approvalTimeBegin
        // eslint-disable-next-line no-unused-expressions
        delete params.approvalTimeEnd && params.approvalTimeEnd
        delete params.approvalTime
      }
      return params
    },
    // 获取车牌号
    async getCarNoList(plateNo) {
      if (!plateNo || plateNo.length < 4) {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
        return
      }
      // state: 1-全部车辆；2-运营中车辆；3-待租车辆；4-待采购车辆
      const { data } = await FuzzySearch({ plateNo, state: 1 })
      const result = data || []
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: result })
    },
    // 清空车牌号
    clearCarNoList() {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
    },
    // 重置
    m_customizeReset() {
      this.clearCarNoList()
    },


  },
  mounted() {
    const { m_parseStoreGetters } = this
    this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'state', data: m_parseStoreGetters('approvalState') })
    this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'accessMode', data: m_parseStoreGetters('approvalType') })
  },
  created() {
    // 获取审批内容
    this.m_getBizTypes()
  },
}
